export const OTP_TYPES = {
    SMS: 'sms',
    WHATSAPP: 'wa',
    EMAIL: 'email'
}
export const format_without_time = "YYYY-MM-DD";
export const format_date_only = 'dd-MM-yyyy';